import { baseApi } from "./baseApi";

const VEHICLE_LISTING_BASE_URL = "/vehicle-listing";

export const vehicleListingApi = baseApi.injectEndpoints({
  tagTypes: ["VehicleListing"],
  endpoints: (build) => ({
    addVehicleListing: build.mutation({
      query: (body) => ({
        url: VEHICLE_LISTING_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "VehicleListing", id: "LIST" }],
    }),

    listVehicleListings: build.query({
      query: (params) => ({
        url: VEHICLE_LISTING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "VehicleListing", id: _id })),
              { type: "VehicleListing", id: "LIST" },
            ]
          : [{ type: "VehicleListing", id: "LIST" }],
    }),

    exportVehicleListings: build.query({
      query: (params) => ({
        url: `${VEHICLE_LISTING_BASE_URL}/export`,
        params,
      }),
    }),

    getDDLVehicleListingList: build.query({
      query: (params) => ({
        url: `${VEHICLE_LISTING_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "VehicleListing", id: _id })),
              { type: "VehicleListing", id: "DDL" },
            ]
          : [{ type: "VehicleListing", id: "DDL" }],
    }),

    getVehicleListingDetail: build.query({
      query: (id) => `${VEHICLE_LISTING_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "VehicleListing", id },
        { type: "VehicleListing", id: "LIST" },
      ],
    }),

    updateVehicleListing: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${VEHICLE_LISTING_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "VehicleListing", id },
        { type: "VehicleListing", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddVehicleListingMutation,
  useListVehicleListingsQuery,
  useLazyListVehicleListingsQuery,
  useLazyExportVehicleListingsQuery,
  useLazyGetDDLVehicleListingListQuery,
  useGetVehicleListingDetailQuery,
  useUpdateVehicleListingMutation,
} = vehicleListingApi;